export type WizardStep = 1 | 2 | 3 | 4 | 5 | 6;

export interface WizardDraft {
  step: WizardStep;
  tenantId?: string;
  name?: string;
  botMode?: 'informational' | 'transactional' | 'hybrid';
  channels: {
    telegram?: { tokenUploaded: boolean; webhookRegistered: boolean };
    whatsapp?: { secretsUploaded: boolean; phoneNumberId?: string; webhookRegistered?: boolean };
  };
  erp?: {
    type: 'laravel' | 'mock' | 'webhook' | 'medical-ese-sf';
    config: Record<string, unknown>;
  };
}

export type WizardAction =
  | { type: 'goto'; step: WizardStep }
  | {
      type: 'set-tenant';
      tenantId: string;
      name: string;
      botMode: 'informational' | 'transactional' | 'hybrid';
    }
  | { type: 'mark-telegram-token' }
  | { type: 'mark-telegram-webhook' }
  | { type: 'mark-whatsapp-secrets'; phoneNumberId: string }
  | { type: 'mark-whatsapp-webhook' }
  | { type: 'set-bot-mode'; botMode: 'informational' | 'transactional' | 'hybrid' }
  | { type: 'set-erp'; erp: NonNullable<WizardDraft['erp']> }
  | { type: 'reset' };

export function wizardReducer(state: WizardDraft, action: WizardAction): WizardDraft {
  const currentState = state ?? { step: 1, channels: {} };

  switch (action.type) {
    case 'goto':
      return { ...currentState, step: action.step };
    case 'set-tenant':
      return {
        ...currentState,
        tenantId: action.tenantId,
        name: action.name,
        botMode: action.botMode,
        step: 2,
      };
    case 'mark-telegram-token':
      return {
        ...currentState,
        channels: {
          ...currentState.channels,
          telegram: {
            ...currentState.channels.telegram,
            tokenUploaded: true,
            webhookRegistered: currentState.channels.telegram?.webhookRegistered ?? false,
          },
        },
      };
    case 'mark-telegram-webhook':
      return {
        ...currentState,
        channels: {
          ...currentState.channels,
          telegram: {
            ...currentState.channels.telegram,
            tokenUploaded: currentState.channels.telegram?.tokenUploaded ?? false,
            webhookRegistered: true,
          },
        },
      };
    case 'mark-whatsapp-secrets':
      return {
        ...currentState,
        channels: {
          ...currentState.channels,
          whatsapp: {
            secretsUploaded: true,
            phoneNumberId: action.phoneNumberId,
            webhookRegistered: currentState.channels.whatsapp?.webhookRegistered ?? false,
          },
        },
      };
    case 'mark-whatsapp-webhook':
      return {
        ...currentState,
        channels: {
          ...currentState.channels,
          whatsapp: {
            secretsUploaded: currentState.channels.whatsapp?.secretsUploaded ?? false,
            phoneNumberId: currentState.channels.whatsapp?.phoneNumberId,
            webhookRegistered: true,
          },
        },
      };
    case 'set-bot-mode':
      return {
        ...currentState,
        botMode: action.botMode,
      };
    case 'set-erp':
      return { ...currentState, erp: action.erp };
    case 'reset':
      return { step: 1, channels: {} };
    default:
      return currentState;
  }
}
